import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';


const QuickActions = () => {
  const { tenant } = useTenant();

  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const actions = [
    { label: 'Add Lead', icon: '👤', path: '/clients?action=new', color: '#2563eb' },
    { label: 'Log Visit', icon: '🚶', path: '/walkins?action=new', color: '#10b981' },
    { label: 'Book Unit', icon: '🏢', path: '/inventory', color: '#f59e0b' },
    { label: 'Share Brochure', icon: '📎', action: 'share', color: '#8b5cf6' }
  ];

  const handleAction = (action) => {
    if (action.path) {
      navigate(action.path);
    } else if (action.action === 'share') {
      const text = encodeURIComponent("Check out ${tenant.name}: https://${tenant.slug}.therealconnect.cloud");
      window.open(`https://wa.me/?text=${text}`, '_blank');
    }
    setIsOpen(false);
  };

  return (
    <div className={`quick-actions-container ${isOpen ? 'open' : ''}`}>
      {isOpen && <div className="quick-actions-overlay" onClick={() => setIsOpen(false)} />}

      <div className="quick-actions-menu">
        {actions.map((action, index) => (
          <div
            key={index}
            className="quick-action-item"
            onClick={() => handleAction(action)}
            style={{ transitionDelay: `${index * 50}ms` }}
          >
            <span className="quick-action-label">{action.label}</span>
            <div className="quick-action-btn" style={{ background: action.color }}>
              {action.icon}
            </div>
          </div>
        ))}
      </div>

      <button
        className="fab-main"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`fab-icon ${isOpen ? 'rotate' : ''}`}>+</span>
      </button>

      <style jsx>{`
        .quick-actions-container {
          position: fixed;
          bottom: 30px;
          right: 30px;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }

        .quick-actions-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(4px);
          z-index: 999;
          animation: fadeIn 0.2s ease;
        }

        .quick-actions-menu {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 16px;
          margin-bottom: 16px;
          pointer-events: none;
        }

        .quick-actions-container.open .quick-actions-menu {
          pointer-events: auto;
        }

        .quick-action-item {
          display: flex;
          align-items: center;
          gap: 12px;
          opacity: 0;
          transform: translateY(20px) scale(0.8);
          transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .quick-actions-container.open .quick-action-item {
          opacity: 1;
          transform: translateY(0) scale(1);
        }

        .quick-action-label {
          background: white;
          padding: 6px 12px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          color: #1f2937;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .quick-action-btn {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 20px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          transition: transform 0.2s;
        }

        .quick-action-btn:hover {
          transform: scale(1.1);
        }

        .fab-main {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
          border: none;
          color: white;
          font-size: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.3);
          z-index: 1001;
          transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .fab-main:hover {
          transform: scale(1.05);
        }

        .fab-icon {
          display: block;
          transition: transform 0.3s;
          line-height: 1;
        }

        .fab-icon.rotate {
          transform: rotate(45deg);
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @media (max-width: 768px) {
          .quick-actions-container {
            bottom: 20px;
            right: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default QuickActions;
